import type { Moment } from 'moment';

export type Week = {
  id:           string;
  range:        { start: Moment; end: Moment };
  number:       number;
  string:       string;
  excludedDays: { date: string, day: number, reason?: string }[];
};

export const allWeeks = 'all';
export type AllWeeks = typeof allWeeks;